var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiceD20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M463.9 116.1l-192-111.9C267 1.438 261.5 0 255.1 0S245 1.438 240.1 4.25l-192 111.9C38.12 121.1 32 132.7 32 144.5v223c0 11.75 6.125 22.48 16.12 28.36l192 111.9C245 510.6 250.5 512 256 512s11-1.438 15.88-4.25l192-111.9C473.9 390 480 379.3 480 367.5V144.5C480 132.7 473.9 121.1 463.9 116.1zM256 87.85l72.5 96.14h-145L256 87.85zM256 339.3L187.8 231.1h136.5L256 339.3zM145.1 254.5l63.38 99.51l-83.38-19.38L145.1 254.5zM366.9 254.5l20 80.13l-83.38 19.38L366.9 254.5zM383.5 177.2l-70.38-93.39l106 61.76L383.5 177.2zM128.5 177.2L92.88 145.6l106-61.76L128.5 177.2zM104.2 219.9L80 317V198.4L104.2 219.9zM232 408.8v38.63l-110.2-64.26L232 408.8zM280 408.8l110.2-25.63L280 447.4V408.8zM432 317l-24.25-97.14L432 198.4V317z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiceD20);
export default __webpack_public_path__ + "static/media/dice-d20.08b8007e48d43f8f023450fd0bdd8fec.svg";
export { ForwardRef as ReactComponent };